import { render } from "./ModelHouseholdEvaluationModal.vue?vue&type=template&id=08bb7230&scoped=true"
import script from "./ModelHouseholdEvaluationModal.vue?vue&type=script&lang=js"
export * from "./ModelHouseholdEvaluationModal.vue?vue&type=script&lang=js"

import "./ModelHouseholdEvaluationModal.vue?vue&type=style&index=0&id=08bb7230&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bb7230"]])

export default __exports__